import { render, staticRenderFns } from "./CombatPanel.vue?vue&type=template&id=5af158a4&scoped=true"
import script from "./CombatPanel.vue?vue&type=script&lang=js"
export * from "./CombatPanel.vue?vue&type=script&lang=js"
import style0 from "./CombatPanel.vue?vue&type=style&index=0&id=5af158a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af158a4",
  null
  
)

export default component.exports